module.exports = __webpack_public_path__ + "img/icon3.aa5ed21b.png";